import {getDispatchers} from '@/api/module/dispatcher';
import {ApiDispatcher} from '@/model/Dispatcher';
import {defineStore} from 'pinia';
import {ref} from 'vue';


export const useDispatcherStore = defineStore('dispatcher', () => {
  const loading = ref(true);
  const initialized = ref(false);
  const error = ref<Error | null>(null);
  const data = ref<ApiDispatcher[]>([]);

  async function fetch() {
    loading.value = true;
    try {
      [data.value] = await getDispatchers();
    } catch (e) {
      error.value = e as Error;
    } finally {
      loading.value = false;
      initialized.value = true;
    }
  }

  function shortToFull(kurz: string): string {
    const result = data.value.find((contact) => contact.Kurz === kurz);
    return result ? result.Name : '';
  }
  return {
    loading,
    error,
    data,
    initialized,
    fetch,
    shortToFull,
  };
});
